<template>
  <div class="apply-form">
    <h1 class="form-title">{{ $cms('c_9a1041fbd10d', 'f_0001', "立即申请，成为魔筷合作商家") }}</h1>
    <div class="form-desc">
      <h2>{{ $cms('c_9a1041fbd10d', 'f_0002', "品牌合作") }}</h2>
      <p>
        {{ $cms('c_9a1041fbd10d', 'f_0003', "想让你的产品快速入驻3000+主播直播间？\n        想借势头部达人打造下一个行业爆款？") }}
        <br><br>
        {{ $cms('c_9a1041fbd10d', 'f_0004', "✅精准匹配|Al智能选品系统，48小时对接目标主播") }}
        <br>
        {{ $cms('c_9a1041fbd10d', 'f_0005', "✅爆款护航|专属运营团队，从脚本到流量全程加持") }}
        <br><br>
{{ $cms('c_9a1041fbd10d', 'f_0006', "📢年度深度合作名额有限") }}
        <br>
        {{ $cms('c_9a1041fbd10d', 'f_0007', "👉🏻立即提报需求，平台中小资源快速触达，让你的产品快速成为市场焦点") }}
        <br>
        {{ $cms('c_9a1041fbd10d', 'f_0008', "立即联系我们，开启你的品牌增长奇迹！") }}
      </p>
    </div>
    <div class="form-content">
      <el-form ref="form" :model="form" :rules="rules" :inline="true" label-position="top">
        <el-form-item class="form-item" prop="brandName" :label="$cms('c_9a1041fbd10d', 'f_0009', &quot;品牌名称&quot;)">
          <el-input v-model="form.brandName" :placeholder="$cms('c_9a1041fbd10d', 'f_0010', &quot;请输入品牌名称&quot;)" class="learn"></el-input>
        </el-form-item>
        <div class="row">
          <el-form-item class="form-item" prop="contactName" :label="$cms('c_9a1041fbd10d', 'f_0011', &quot;联系人姓名，职位&quot;)">
            <el-input v-model="form.contactName" :placeholder="$cms('c_9a1041fbd10d', 'f_0012', &quot;请输入联系人姓名，职位&quot;)" class="learn"></el-input>
          </el-form-item>

          <el-form-item class="form-item" prop="contactPhone" :label="$cms('c_9a1041fbd10d', 'f_0013', &quot;联系方式（电话/微信）&quot;)">
            <el-input v-model="form.contactPhone" :placeholder="$cms('c_9a1041fbd10d', 'f_0014', &quot;请输入联系方式&quot;)" class="learn"></el-input>
          </el-form-item>
        </div>
        <el-form-item class="form-item" prop="fileList" :label="$cms('c_9a1041fbd10d', 'f_0015', &quot;品牌货盘&quot;)">
          <file-upload 
            v-model="form.fileList" 
            :multiple="true" 
            :max="5" 
            accept="application/pdf,application/vnd.ms-excel"
            @success="onUploadSuccess"
            @error="onUploadError"
          >
            <div class="up-box">{{ $cms('c_9a1041fbd10d', 'f_0016', "上传文件（PDF或者Excel）") }}</div>
          </file-upload>
        </el-form-item>
        <el-form-item class="form-item" prop="companyIntro" :label="$cms('c_9a1041fbd10d', 'f_0017', &quot;公司介绍&quot;)">
          <el-input v-model="form.companyIntro" :placeholder="$cms('c_9a1041fbd10d', 'f_0018', &quot;请输入公司介绍&quot;)" class="learn"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div 
      class="submit-btn" 
      :class="{ 'submitting': isSubmitting }"
      @click="submitForm"
    >
      <span v-if="!isSubmitting">{{ $cms('c_9a1041fbd10d', 'f_0019', "提交申请") }}</span>
      <span v-else>{{ $cms('c_9a1041fbd10d', 'f_0020', "提交中...") }}</span>
    </div>
  </div>
</template>

<script>
import FileUpload from '@/components/FileUpload.vue';

export default {
  name: 'Type2Form',
  components: {
    FileUpload,
  },
  props: {
    isSubmitting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        brandName: '',
        contactName: '',
        contactPhone: '',
        fileList: [], // v-model 绑定的文件列表
        companyIntro: ''
      },
      rules: {
        brandName: [
          { required: true, message: '请输入品牌名称', trigger: 'blur' },
        ],
        contactName: [
          { required: true, message: '请输入联系人姓名，职位', trigger: 'blur' },
        ],
        contactPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
        ],
        fileList: [
          { required: true, message: '请上传品牌货盘', trigger: 'change' },
        ],
        companyIntro: [
          { required: true, message: '请输入公司介绍', trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    onUploadSuccess(url) {
      console.log('文件上传成功:', url);
      console.log('当前文件列表:', this.form.fileList);
      this.$emit('upload-success', url);
    },

    onUploadError(error) {
      console.error('上传失败:', error);
      this.$message.error('文件上传失败');
      this.$emit('upload-error', error);
    },

    // 提交表单
    submitForm() {
      if (this.isSubmitting) {
        return; // 如果正在提交，直接返回
      }
      
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log('表单数据:', this.form);
          this.$emit('submit', this.form);
        } else {
          this.$message.error('请填写完整信息');
        }
      });
    },

    // 获取表单数据
    getFormData() {
      return this.form;
    },

    // 验证表单
    validateForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          resolve(valid);
        });
      });
    }
  },
}
</script>

<style lang="less" scoped>
@import "./apply-join.less";
</style>
